var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.$store.state.emp.cod_empresa == 383)?_c('ReporteConab'):_vm._e(),(_vm.$store.state.emp.cod_empresa == 381)?_c('ReporteSwisstex'):_vm._e(),(_vm.$store.state.emp.cod_empresa == 380)?_c('ReporteUnique'):_vm._e(),(_vm.$store.state.emp.cod_empresa == 398)?_c('ReportePersonalSoft'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }